import { render, staticRenderFns } from "./CreateSelection.vue?vue&type=template&id=37c25946&scoped=true"
import script from "./CreateSelection.vue?vue&type=script&lang=js"
export * from "./CreateSelection.vue?vue&type=script&lang=js"
import style0 from "./CreateSelection.vue?vue&type=style&index=0&id=37c25946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c25946",
  null
  
)

export default component.exports